import { put, takeLatest, call, all } from 'redux-saga/effects';
import types from '../../types';
import api from '../../../services/api';
import { modal } from '../../../components/Base/Modal';
import notification from '../../../services/notification';
import { checkVerifyStatusUserKYC } from '../../users/actions';

function* getUserInfo({ payload }) {
  try {
    const { data, status } = yield call(api.profile.getUserAccount, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_USER_ACCOUNT_SUCCESS, payload: data });
    yield put({ type: types.GET_USER_KYC_VERIFICATIONS_START, payload });
  } catch (error) {
    yield put({ type: types.GET_USER_ACCOUNT_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

function* getUserKycVerifications({ payload }) {
  try {
    const { data, status } = yield call(
      api.profile.getUserKycVerifications,
      payload,
    );
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_USER_KYC_VERIFICATIONS_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_USER_KYC_VERIFICATIONS_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

// function* checkKycVerify({ payload }) {
//   try {
//     const { data, status } = yield call(
//       api.profile.getUserKycVerifications,
//       payload,
//     );
//     if (status < 200 || status >= 300) throw new Error('Something went wrong');

//     yield all(
//       data?.kyc_verifications.map(item => {
//         if (item?.status !== 'approved') {
//           return call(checkVerifyStatusUserKYC, item, payload);
//         }
//         return undefined;
//       }),
//     );

//     yield put({ type: types.CHECK_VERIFY_USER_KYC_STATUS_SUCCESS });
//   } catch (error) {
//     yield put({ type: types.CHECK_VERIFY_USER_KYC_STATUS_FAILURE });
//     if (error?.response?.status === 401) return;
//     console.dir(error);
//   }
// }

// function* updateKycVerify({ payload }) {
//   try {
//     const { data, status } = yield call(api.profile.updateKycVerifications, payload);
//     if (status < 200 || status >= 300) throw new Error('Something went wrong');

//     yield put({
//       type: types.UPDATE_USER_KYC_VERIFICATIONS_SUCCESS,
//       payload: data,
//     });

//     yield put({ type: types.GET_USER_KYC_VERIFICATIONS_START, payload: payload.id });
//   } catch (error) {
//     yield put({ type: types.UPDATE_USER_KYC_VERIFICATIONS_FAILURE });
//     if (error?.response?.status === 401) return;
//     console.dir(error);
//   }
// }

function* reset2FA({ payload }) {
  try {
    const { status } = yield call(api.profile.putDisable2FA, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.PUT_DISABLE_2FA_SUCCESS });
    yield put({ type: types.GET_USER_ACCOUNT_START, payload });
  } catch (error) {
    yield put({ type: types.PUT_DISABLE_2FA_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

function* updateKycDocumentStatus({ payload }) {
  try {
    const { status } = yield call(api.profile.putKycDocumentStatus, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.UPDATE_USER_STATUS_SUCCESS });
    modal.close();

    if (payload.data.status === 2) {
      notification({
        type: 'success',
        title: 'User',
        message: 'Document is approved.',
      });
    }
    if (payload.data.status === 4) {
      notification({
        type: 'success',
        title: 'User',
        message: 'Document is rejected.',
      });
    }
  } catch (e) {
    console.log('erorr', e)
    notification({ type: 'error', message: 'Error. Please try again later.' });
    if (e?.response?.status === 401) {
      notification({
        type: 'error',
        title: 'User',
        message: 'Error. Please try again later.',
      });
    }
    if (e?.response?.data?.errors.includes('user_already_approved')) {
      notification({
        type: 'error',
        title: 'User',
        message: 'User is already aproved.',
      });
    }
  }
}

function* updateUserStatus({ payload }) {
  try {
    const { status } = yield call(api.profile.putUserStatus, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.UPDATE_USER_STATUS_SUCCESS });
    yield put({ type: types.GET_USER_ACCOUNT_START, payload: payload.id });
    modal.close();

    if (payload.data.status === 2) {
      notification({
        type: 'success',
        title: 'User',
        message: 'User is approved.',
      });
    }
    if (payload.data.status === 4) {
      notification({
        type: 'success',
        title: 'User',
        message: 'User is rejected.',
      });
    }
  } catch (e) {
    notification({ type: 'error', message: 'Error. Please try again later.' });
    yield put({ type: types.UPDATE_USER_STATUS_FAILURE });
    if (e?.response?.status === 401) {
      notification({
        type: 'error',
        title: 'User',
        message: 'Error. Please try again later.',
      });
    }
    if (e?.response?.data?.errors.includes('user_already_approved')) {
      notification({
        type: 'error',
        title: 'User',
        message: 'User is already aproved.',
      });
    }
  }
}

function* putClearUserPhoneNumber({ payload }) {
  try {
    const { data, status } = yield call(
      api.profile.putClearUserPhoneNumber,
      payload,
    );
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.PUT_CLEAR_USER_PHONE_NUMBER_SUCCESS });
  } catch (error) {
    yield put({ type: types.PUT_CLEAR_USER_PHONE_NUMBER_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

// function* putSetUserPhoneNumber({ payload }) {
//   try {
//     const { data, status } = yield call(api.profile.putSetUserPhoneNumber, payload);
//     if (status < 200 || status >= 300) throw new Error('Something went wrong');
//     yield put({ type: types.PUT_SET_USER_PHONE_NUMBER_SUCCESS, payload });
//   } catch (error) {
//     yield put({ type: types.PUT_SET_USER_PHONE_NUMBER_FAILURE });
//     if (error?.response?.status === 401) return;
//     notification({ type: 'error', message: 'Something went wrong' });
//   }
// }

export function* user() {
  yield all([
    yield takeLatest(types.GET_USER_ACCOUNT_START, getUserInfo),
    yield takeLatest(
      types.GET_USER_KYC_VERIFICATIONS_START,
      getUserKycVerifications,
    ),
    // yield takeLatest(types.UPDATE_USER_KYC_VERIFICATIONS_START, updateKycVerify),
    yield takeLatest(types.PUT_DISABLE_2FA_START, reset2FA),
    yield takeLatest(types.UPDATE_USER_STATUS_START, updateUserStatus),
    yield takeLatest(types.UPDATE_KYC_STATUS_DOCUMENT, updateKycDocumentStatus),

    // yield takeLatest(types.CHECK_VERIFY_USER_KYC_STATUS_START, checkKycVerify),
    yield takeLatest(
      types.PUT_CLEAR_USER_PHONE_NUMBER_START,
      putClearUserPhoneNumber,
    ),
    // yield takeLatest(types.PUT_SET_USER_PHONE_NUMBER_START, putSetUserPhoneNumber),
  ]);
}
